import * as React from "react";

import { ISystem } from "../../api/models/ISystem";
import { TResourceState } from "../../types/TResourceState";
import { IDriverset } from "../../api/models";

type TMode = 'list' | 'view' | 'add' | 'edit';
type TTab = 'info' | 'datasets' | 'driversets';

interface ISystemsContext {
  mode: TMode;
  setMode: (mode: TMode) => void;
  tab: TTab,
  setTab: (value: TTab) => void;

  systems: ISystem[];
  loadSystems: () => void;
  systemsReady: TResourceState;
  setSystemsReady: (value: TResourceState) => void;

  system: ISystem | null;
  setSystem: (system: ISystem | null) => void;
  systemReady: TResourceState;
  setSystemReady: (value: TResourceState) => void;

  driverset: IDriverset | null;
  setDriverset: (value: IDriverset | null) => void;

  loadSystem: (system: ISystem) => Promise<ISystem | null>;
  parseSystem: () => void;
  createSystem: (system: ISystem, signal: AbortSignal) => Promise<boolean>;
  updateSystem: (system: ISystem, signal: AbortSignal) => Promise<boolean>;
  deleteSystem: () => void;
}

const SystemsContext = React.createContext<ISystemsContext | null>(null);

const useSystemsContext = (): ISystemsContext => {
  const ctx = React.useContext(SystemsContext);
  if (!ctx) throw new Error('useSystemsContext must be used inside a <SystemsContext> provider.');
  return ctx;
}

export { SystemsContext, ISystemsContext, useSystemsContext, TMode, TTab }
